const _SelfDebug_clientLog = Symbol("#clientLog"),
      _SelfDebug_getText = Symbol("#getText"),
      _SelfDebug_getCursorIndex = Symbol("#getCursorIndex"),
      _SelfDebug_clientLogSnapshot = Symbol("#clientLogSnapshot");

export class SelfDebug {
  constructor() {
    this[_SelfDebug_clientLog] = [];
  }

  watchEditor(getText, getCursorIndex) {
    this[_SelfDebug_getText] = getText;
    this[_SelfDebug_getCursorIndex] = getCursorIndex;
  }

  log(event, message) {
    this[_SelfDebug_clientLog].push({
      time: new Date(),
      event,
      message,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      text: this[_SelfDebug_getText](),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      cursor: this[_SelfDebug_getCursorIndex]()
    });

    while (this[_SelfDebug_clientLog].length > 100) {
      this[_SelfDebug_clientLog].shift();
    }
  }

  requestData(connection) {
    this[_SelfDebug_clientLogSnapshot] = this[_SelfDebug_clientLog].slice(0);
    return connection.sendRequestSelfDebugData();
  }

  displayData(serverData) {
    const log = []; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    for (let i = 0; i < this[_SelfDebug_clientLogSnapshot].length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      log.push({
        entry: this[_SelfDebug_clientLogSnapshot][i],
        on: 'client',
        index: i
      });
    }

    for (let i = 0; i < serverData.log.length; i++) {
      log.push({
        entry: serverData.log[i],
        on: 'server',
        index: i
      });
    }

    log.sort((a, b) => {
      if (a.on !== b.on) {
        if (a.entry.time > b.entry.time) return +1;
        if (a.entry.time < b.entry.time) return -1;
        return 0;
      }

      if (a.index > b.index) return +1;
      if (a.index < b.index) return -1;
      return 0;
    });
    console.table(log.map(l => {
      const time = l.entry.time;
      const displayTime = ('0' + time.getHours()).slice(-2) + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + ('0' + time.getSeconds()).slice(-2) + '.' + time.getMilliseconds();
      return {
        time: displayTime,
        message: l.entry.message,
        event: l.on + ':' + l.entry.event,
        cursor: l.entry.cursor,
        text: l.entry.text
      };
    }));
  }

}